<div class="jumbotron-bg space" [ngStyle]="bgStyle" [class.rootpage-jumbotron]="isRootPage">
    <swiper-gallery  [ngStyle]="bgStyle" [items]="pagePictures" [config]="swiperConfig" [thumbnails]="false" [closing]=""false></swiper-gallery>

    <div class="jumbotron-content layout-corral">

        <header-user-bar dir="ltr"></header-user-bar>
        <div class="jumbotron-content-center" *ngIf="contentCenter">
            <h1 [ngStyle]="h1Style">{{name}}</h1>
            <!-- <h1 *ngIf="isRootPage" [ngStyle]="h1Style">
                Сертификация<br>
                продукции, работ и услуг</h1> -->
            <h4 *ngIf="since">
                <a href="https://vniigaz.gazprom.ru/" target="_blank">Учреждено в 1998</a>
            </h4>
        </div>

    </div>
</div>
<div class="space jumbotron-edit-field" *ngIf="editable" dir="ltr">
    <div class="layout-corral jumbotron-edit-field-row">
        <button class="btn outline" (click)="showJumbotronEditor=true">редактировать слайды</button>
        <div class="switch-host" (click)="toggleEditMode()">
            Режим редактирования
            <switch [val]="editMode"></switch>
        </div>
    </div>
</div>
<modal class="jumbotronEditor" *ngIf="showJumbotronEditor" (close)="showJumbotronEditor=false">
    <h4 header>Редактирование слайдов</h4>
    <div *ngIf="slides.length===0">Список слайдов пуст</div>
    <div class="jumbotronEditorCard">
        <div *ngFor="let slide of slides; let i=index" class="jumbotronEditorSlide">
            <img [src]= "slideImg(slide)">
            <div>
                <h4>{{slideHeader(slide)}}</h4>
                <span>{{slideSubheader(slide)}}</span>
                <span class="jumb-text">{{slideText(slide)}}</span>
                <span class="jumb-link">{{slideLink(slide)}}</span>
                <div class="slideEditorBlock">
                    <ico class="up" ico="arrow_upward_24" (click)="slideMove(slide, slideOrd(slide) - 1)" *ngIf="i!=0"></ico>
                    <ico class="down" ico="arrow_downward_24" *ngIf="i+1!=slides.length"  (click)="slideMove(slide, slideOrd(slide) + 1)"></ico>
                    <ico ico="edit_24"  (click)="slideEdit(slide)"></ico>
                    <ico ico="delete_24"  (click)="slideDestroy(slide)"></ico>
                </div>
            </div>
        </div>
    </div>
    <div  footer>
        <button (click)="slideAdd()" class="outline">Добавить слайд</button>
    </div>
    
</modal>
